import { Icon } from "@/components/atoms";
import { Company } from "@/redux/slices/company/types";
import { getAssetUrl } from "@/utils";

interface CompanyAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  company: Company;
  openUploader: () => void;
}

export const CompanyAvatar = ({ company, openUploader, className, ...props }: CompanyAvatarProps) => {
  const renderCameraIcon = () => (
    <>
      <div
        className="absolute bottom-1 right-1 hidden h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-info hover:opacity-80 lg:flex"
        onClick={openUploader}
      >
        <Icon name="Camera" variant="Bold" size="md" className="text-white" />
      </div>
      <div
        className="absolute bottom-0 right-0 flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-info hover:opacity-80 lg:hidden"
        onClick={openUploader}
      >
        <Icon name="Camera" variant="Bold" size="sm" className="text-white" />
      </div>
    </>
  );

  return (
    <div className={className} {...props}>
      {company.avatar ? (
        <div className="relative h-[72px] w-[72px] lg:h-[124px] lg:w-[124px]">
          <img src={getAssetUrl(company.avatar)} alt={company.name} className="h-full w-full rounded-full" />
          {renderCameraIcon()}
        </div>
      ) : (
        <div className="relative flex h-[72px] w-[72px] items-center justify-center rounded-full bg-primary-light lg:h-[124px] lg:w-[124px]">
          <Icon name="Buildings" className="h-9 w-9 text-primary-dark lg:h-16 lg:w-16" />
          {renderCameraIcon()}
        </div>
      )}
    </div>
  );
};
